var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component component__library_grid"},[_c('div',{staticClass:"container"},[_c('div',{class:[
            'columns',
            'is-multiline',
            'columns--custom-desktop-tablet',
            'columns--custom-desktop-margin',
            'columns--custom-widescreen-margin',
            'is-variable',
            'is-8-touch'
        ]},[_vm._l((_vm.items),function(item,index){return [_c('div',{key:index,class:[
                        'column',
                        'column--custom-tablet-padding',
                        'column--custom-desktop-padding',
                        'column--custom-widescreen-padding',
                        'column--custom-tablet-width',
                        'column--custom-desktop-width',
                        'column--custom-widescreen-width',
                        'is-3-desktop',
                        'is-4-tablet',
                        'is-6-mobile'
                    ]},[_c('component-library-grid-item',{class:_vm.selected.includes(item.id) ? 'component__library_grid_item--selected' : '',attrs:{"item":item,"checkbox-active":_vm.checkboxActive},on:{"emit-check":_vm.emitCheck,"emit-click":_vm.emitClick}})],1)]})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }